import {initWizard} from '../Wizard/Wizard';
import {initializeStripeInstance, isStripeReady} from '../Stripe/Stripe';

const initCreateStoreWizard = wizard => {
    let stripeInitialized = false;

    const cardDetails  = wizard.querySelector('.card-details');
    const submitButton = wizard.querySelector('[data-wizard-submit]');

    const initStripeIfNeeded = () => {
        if (stripeInitialized) {
            return;
        }

        const billingSetupMethodRadio = wizard.querySelector('input[name="billingSetupMethod"]:checked');

        if (billingSetupMethodRadio && billingSetupMethodRadio.value !== 'separate') {
            return;
        }

        stripeInitialized = true;
        initializeStripeInstance(cardDetails);
    };

    initWizard(wizard, {
        validate(panel) {
            if (panel.dataset.wizardStep === 'details') {
                const nameInput = panel.querySelector('input[name="name"]');

                if (!nameInput.reportValidity()) {
                    nameInput.focus();

                    return false;
                }
            }

            return true;
        },

        onStepEnter(panel) {
            if (panel.dataset.wizardStep === 'billing') {
                initStripeIfNeeded();
            }
        },
    });

    wizard.addEventListener('card-toggled', event => {
        if (event.detail?.value === 'separate') {
            initStripeIfNeeded();
            submitButton.disabled = !isStripeReady(cardDetails);
        }

        if (event.detail?.value === 'link') {
            submitButton.disabled = false;
        }
    });

    const form = wizard.querySelector('form');

    if (form) {
        form.addEventListener('submit', () => {
            const billingSetupMethodRadio = wizard.querySelector('input[name="billingSetupMethod"]:checked');

            if (billingSetupMethodRadio && billingSetupMethodRadio.value === 'link') {
                cardDetails.remove();
            }
        }, {capture: true});
    }

    const nameInput = wizard.querySelector('input[name="name"]');

    nameInput.required = true;

    if (!wizard.dataset.initialStep) {
        nameInput?.focus();
    }

    const infoBox = wizard.querySelector('.linked-billing-info');
    const plusContent = wizard.querySelector('#linked-plus-content');
    const planContent = wizard.querySelector('#linked-plan-content');
    const planSelector = wizard.querySelector('#plan-selector');
    const linkedPlanTarget = wizard.querySelector('#linked-plan-target');
    const separatePanel = wizard.querySelector('#pay-separately-panel');

    const storeSearch = wizard.querySelector('#copy-settings-panel input[type="search"]');

    storeSearch?.addEventListener('input', () => {
        const selected = wizard.querySelector('input[name="storeDuplicationTarget"]:checked');

        if (selected && selected.closest('label').style.display === 'none') {
            selected.checked = false;
        }
    });

    if (infoBox && planSelector) {
        const updateLinkedBillingState = () => {
            const selected = wizard.querySelector('input[name="parentStore"]:checked');

            if (!selected) {
                infoBox.classList.add('hidden');
                return;
            }

            const isPlus = selected.dataset.storePlan.startsWith('plus');

            infoBox.classList.remove('hidden');
            plusContent.classList.toggle('hidden', !isPlus);
            planContent.classList.toggle('hidden', isPlus);

            if (isPlus) {
                infoBox.querySelector('#linked-new-store').textContent =
                    nameInput?.value.trim() || 'Your new store';
                infoBox.querySelector('#linked-parent-store').textContent =
                    selected.dataset.storeName;
            } else {
                linkedPlanTarget.appendChild(planSelector);
                planSelector.classList.remove('hidden');
            }
        };

        wizard.querySelectorAll('input[name="parentStore"]').forEach(radio => {
            radio.addEventListener('change', updateLinkedBillingState);
        });

        nameInput?.addEventListener('input', updateLinkedBillingState);

        wizard.addEventListener('card-toggled', event => {
            if (event.detail?.value === 'separate') {
                separatePanel.prepend(planSelector);
                planSelector.classList.remove('hidden');
                infoBox.classList.add('hidden');
            } else {
                updateLinkedBillingState();
            }
        });

        updateLinkedBillingState();
    }
};

export {initCreateStoreWizard};
